import { useState } from 'react'

export default function ShareBar({ url }: { url: string }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // クリップボード非対応環境では手動コピーに任せる
    }
  }

  return (
    <div className="flex items-center gap-2 rounded-xl border border-line bg-surface px-3 py-2">
      <span className="shrink-0 text-xs font-medium text-muted">共有リンク</span>
      <input
        readOnly
        value={url}
        onFocus={(e) => e.currentTarget.select()}
        className="min-w-0 flex-1 bg-transparent text-sm text-ink outline-none"
      />
      <button
        onClick={copy}
        className="shrink-0 rounded-lg bg-brand px-3 py-1.5 text-xs font-semibold text-white transition hover:bg-brand-ink"
      >
        {copied ? 'コピー済み' : 'コピー'}
      </button>
    </div>
  )
}
